import { User } from '@/typings/user';
import { UserSuperRole } from '@/typings/user';

export type UserRoles = (typeof UserRoles)[keyof typeof UserRoles];
export const UserRoles = {
  super: 'SUPER_ADMIN',
  admin: 'ADMIN',
  user: 'USER',
  attendant: 'ATTENDANT',
} as const;

export const rolesWithLabels = [
  {
    label: 'Super',
    value: UserRoles.super,
  },
  {
    label: 'Administrador',
    value: UserRoles.admin,
  },
  {
    label: 'Usuário',
    value: UserRoles.user,
  },
  {
    label: 'Atendente',
    value: UserRoles.attendant,
  },
];

export function getRoleLabel(role: string) {
  const roleFound = rolesWithLabels.find((item) => item.value === role);
  return roleFound ? roleFound.label : role;
}

export const isSuperAdmin = (user?: User | null) => user?.superRole === UserRoles.super;

export const isSuperSupportUser = (user?: User | null) =>
  user?.superRole === UserSuperRole.SUPER_ADMIN || user?.superRole === UserSuperRole.SUPPORT;
